export type Tool = {
  section: 'top' | 'bottom';
  label: string;
  group: string;
  icon?: () => Promise<unknown> | string;
  control: string;
  args: Record<string, string>;
  id: string;
};
export const createCustomTools = function createCustomTools(): Tool[] {
  return [
    {
      section: 'top',
      label: 'apply-modal-control',
      group: 'g0',
      icon: () => import('@carbon/icons-vue/es/image/20'),
      control: 'apply-modal-control',
      id: 'logo-library',
      args: {},
    },
    {
      section: 'top',
      label: 'apply-text-control',
      group: 'g1',
      icon: () => import('@carbon/icons-vue/es/text--creation/20'),
      control: 'apply-text-control',
      id: 'add-text',
      args: {
        label: 'T',
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        template: require('../templates').defaultTextTemplate,
      },
    },
    {
      section: 'top',
      label: 'apply-pan-mode',
      group: 'g2',
      icon: undefined,
      control: 'apply-pan-mode',
      id: 'move-image',
      args: {
        name: 'pan',
      },
    },
    {
      section: 'top',
      label: 'apply-select-mode',
      group: 'g3',
      icon: undefined,
      control: 'apply-select-mode',
      id: 'move-logo',
      args: {
        name: 'auto',
      },
    },
    {
      section: 'top',
      label: 'lanyard-options',
      group: 'g4',
      icon: undefined,
      control: 'lanyard-options',
      id: 'lanyard',
      args: {},
    },
    {
      section: 'top',
      label: 'round-item-options',
      group: 'g5',
      icon: undefined,
      control: 'round-item-options',
      id: 'roundItems',
      args: {},
    },
    {
      section: 'bottom',
      id: 'undo',
      label: 'apply-history-back-control',
      group: 'g3',
      icon: () => import('@carbon/icons-vue/es/undo/20'),
      control: 'apply-history-back-control',
      args: {},
    },
    {
      section: 'bottom',
      id: 'redo',
      label: 'apply-history-forward-control',
      group: 'g3',
      icon: () => import('@carbon/icons-vue/es/redo/20'),
      control: 'apply-history-forward-control',
      args: {},
    },
  ];
};
